import {
  VIEWPORT_DEFAULT_DESKTOP,
  VIEWPORT_DEFAULT_LARGE_DESKTOP,
  VIEWPORT_DEFAULT_MOBILE,
  VIEWPORT_DEFAULT_TABLET,
  VIEWPORT_DEFAULT_VERY_LARGE_DESKTOP,
  VIEWPORT_MOBILE_SMALL
} from 'modules/viewport/constants'
import createViewportUtil from 'modules/viewport/utils/create'

export function isSmallMobileScreenViewportUtil (viewport = createViewportUtil()) {
  return viewport.width <= VIEWPORT_MOBILE_SMALL.width
}

export function isMobileScreenViewportUtil (viewport = createViewportUtil()) {
  return viewport.width <= VIEWPORT_DEFAULT_MOBILE.width
}

export function isTabletScreenViewportUtil (viewport = createViewportUtil()) {
  return viewport.width <= VIEWPORT_DEFAULT_TABLET.width
}

export function isSmallScreenViewportUtil (viewport = createViewportUtil()) {
  return viewport.width < VIEWPORT_DEFAULT_DESKTOP.width
}

export function isLargeScreenViewportUtil (viewport = createViewportUtil()) {
  return viewport.width > VIEWPORT_DEFAULT_LARGE_DESKTOP.width
}

export function isVeryLargeScreenViewportUtil (viewport = createViewportUtil()) {
  return viewport.width > VIEWPORT_DEFAULT_VERY_LARGE_DESKTOP.width
}

export function getWidthViewportUtil (viewport = createViewportUtil()) {
  return viewport.width
}

export function getHeightViewportUtil (viewport = createViewportUtil()) {
  return viewport.height
}
